/**
 * Vite build-time env, isolated behind a module boundary.
 *
 * `import.meta.env.<LITERAL>` is statically replaced by Vite at build time, so
 * this keeps the production behavior identical while confining the (only)
 * `import.meta` reference to a single module. That matters for Jest: ts-jest
 * compiles to CommonJS, where an `import.meta` token is a parse error. Tests
 * `jest.mock('../api/env')` (or the module map) so the data layer can be
 * imported without tripping over `import.meta`.
 */

/** Base URL for the super-admin Function App; empty string → Vite dev proxy. */
export const apiBaseUrl: string =
  (import.meta.env.VITE_SUPERADMIN_API_BASE as string | undefined) ?? '';
